import React, { createRef } from 'react';
import { IonModal, IonButton, IonChip, IonCard, IonCardHeader, IonCardTitle, IonCardContent, IonActionSheet, IonInput, IonButtons, IonBackButton, IonFab, IonFabButton, IonIcon, IonContent, IonHeader, IonItem, IonLabel, IonList, IonPage, IonTitle, IonToolbar, withIonLifeCycle } from '@ionic/react';
import '../styles/Studyset.scss';
import Storage from '../Storage';
import Utilities from '../Utilities';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import { close, closeCircle } from 'ionicons/icons'
import '../styles/TagEditorModal.scss';
import { isPlatform } from '@ionic/react';

import { Keyboard } from '@capacitor/keyboard';

class TagEditorModal extends React.Component {

    constructor(props) {

        super(props);
        this.modalRef = createRef();
        this.state = {
            error: null
        }

        if (isPlatform("ios")) {

            Keyboard.addListener('keyboardWillShow', (info) => {
                this.setState({ keyboardShowing: true })
                window.keyboardHeight = info.keyboardHeight;
                if (this.modalRef.current) {
                    this.modalRef.current.parentNode.style.setProperty('bottom', info.keyboardHeight + "px");
                    this.modalRef.current.parentNode.style.setProperty('bottom', info.keyboardHeight + "px");
                }
            });

            Keyboard.addListener('keyboardWillHide', () => {
                this.setState({ keyboardShowing: false })
                if (this.modalRef.current) {
                    this.modalRef.current.parentNode.style.setProperty('bottom', 0 + "px");
                    // this.modalRef.current.style.setProperty('margin-top', "12px", "important");
                }
            });

        }

    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.currentlyEditedTag && (!this.state.currentlyEditedTag || (this.state.currentlyEditedTag && this.state.currentlyEditedTag.id !== nextProps.currentlyEditedTag.id) )) {
            this.setState({
                currentlyEditedTag: nextProps.currentlyEditedTag
            })
            Utilities.onDrawerShow();
        }
    }

    save(ignoreErrorExit) {

        this.setState({ error: null })

        if (!this.state.currentlyEditedTag.name.trim()) {
            this.setState({ error: window.ln.enterTagName });
            return;
        }

        if (this.state.currentlyEditedTag.name === "learnt" || this.state.currentlyEditedTag.name === "star" || this.state.currentlyEditedTag.name === "mastered" || this.state.currentlyEditedTag.name === "studying" || this.state.currentlyEditedTag.name === "new" || this.state.currentlyEditedTag.name === "image" || this.state.currentlyEditedTag.name === "recording" ) {
            this.setState({ error: window.ln.invalidName });
            return;
        }

        Utilities.trackEvent("Tag", "Tag Save", this.state.currentlyEditedTag.id + "|" + this.state.currentlyEditedTag.name);

        this.props.onSave(this.state.currentlyEditedTag);
        this.props.onClose();

    }

    render() {
        return (
            <SwipeableDrawer
                anchor="bottom"
                open={(this.props.currentlyEditedTag !== null)}
                key="flashcard-editor"
                onClose={ () => {
                    this.props.onClose(true);
                } }
                onOpen={ () => {

                } }
            >
                <div 
                    className="tag-editor-modal"
                    data-keyboard-showing={this.state.keyboardShowing} 
                    ref={this.modalRef} 
                >
                    <div className="drag-indicator"></div>
                    <h2>{( (this.state.currentlyEditedTag && this.state.currentlyEditedTag.id === "new" ? window.ln.create : window.ln.edit) + " " + window.ln.tag )}</h2>
                    <div className="drag-close-indicator" onClick={() => {
                        Utilities.onDrawerHide();
                        this.props.onClose(true);
                    }}>
                        <IonIcon icon={closeCircle} />
                    </div>
                    { (this.state.currentlyEditedTag) &&
                        <section className="edit">
                            <IonItem>
                                <IonLabel position="stacked">{window.ln.name}</IonLabel>
                                <IonInput
                                    value={this.state.currentlyEditedTag.name}
                                    onIonChange={(e) => {
                                        let tag = this.state.currentlyEditedTag;
                                        tag.name = e.target.value;
                                        this.setState({ currentlyEditedTag: tag })
                                    }}
                                    placeholder={window.ln.tagName}
                                    type="text"
                                />
                            </IonItem>
                            <IonItem>
                                <IonLabel position="stacked">{window.ln.color}</IonLabel>
                                <div className="color-picker">
                                    { ( (window.globalVars) && (window.globalVars.tagColors) ) && window.globalVars.tagColors.map(color => {
                                        return (
                                            <div
                                                className="color"
                                                data-color={color.id}
                                                data-selected={color.id === this.state.currentlyEditedTag.color}
                                                onClick={() => {
                                                    let tag = this.state.currentlyEditedTag;
                                                    tag.color = color.id;
                                                    this.setState({ currentlyEditedTag: tag })
                                                }}
                                            />
                                        )
                                    }) }
                                </div>
                            </IonItem>
                            { (this.state.error) &&
                                <p className="status error">{this.state.error}</p>
                            }
                            <div className="opts">
                                <div className="right">
                                    <button onClick={() => { this.save(); }}>{window.ln.save}</button>
                                </div>
                            </div>
                        </section>
                    }
               </div>
           </SwipeableDrawer>
        );
    }

};


export default withIonLifeCycle(TagEditorModal);
